import { render } from "./addRole.vue?vue&type=template&id=18814533&scoped=true"
import script from "./addRole.vue?vue&type=script&lang=js"
export * from "./addRole.vue?vue&type=script&lang=js"

import "./addRole.vue?vue&type=style&index=0&id=18814533&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18814533"]])

export default __exports__